import { usePoolRoomsQuery as e } from "./usePoolRoomsQuery.mjs";
import { PoolRoomStatus as t } from "@maat/api-main/types";
//#region src/properties/usePoolSiblingRooms.ts
var n = (n, r) => {
	let { groups: i } = e([n]);
	for (let e of i.values()) {
		let n = e.rooms.find((e) => e.id === r);
		if (n) return { rooms: {
			current: n,
			siblings: e.rooms.filter((e) => e.id !== n.id && e.status === t.Active)
		} };
	}
	return { rooms: null };
};
//#endregion
export { n as usePoolSiblingRooms };
